import { IAllBetDTO, ILiveBetsItem } from "../types";
import { getCurrencyIcon, getVipLevelIcon, getVipLevelString } from "app/utils/help";
import { CurrencySymbol } from "app/types/common";

export const mutateAllBetsData = (data: IAllBetDTO, i: number): ILiveBetsItem => {
    const dis = Number(data.netAmount);

    return {
        id: data.billNo,
        key: data.billNo,
        gameId: data.gameId,
        dark: !!(i % 2),
        game: {
            image: data.gameName,
            name: data.gameName,
        },
        player: {
            image: getVipLevelIcon(data.level),
            name: data.playerName,
            level: getVipLevelString(data.level) || 'bronze'
        },
        wager: {
            value: Number(data.betAmount)?.toFixed(2),
            currency: CurrencySymbol[data.tokenId as keyof typeof CurrencySymbol],
            icon: getCurrencyIcon(data.tokenId),
        },
        multiplier: {
            growth: dis > 0 ? "+" : "-",
            value: data?.payout?.toFixed(2),
        },
        payoutCol: {
            value: dis > 0 ? Number(data.netAmount)?.toFixed(2) : '0.00',
            currency: CurrencySymbol[data.tokenId as keyof typeof CurrencySymbol],
            icon: getCurrencyIcon(data.tokenId),
        },
        tokenId: data.tokenId
    }
};

